import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TeamsStore, for use in the registry */ export const TeamsStoreActionTypes = [
    ActionType.DeleteTeamsTasksTabSucceeded,
    ActionType.FetchTeamsTasksTabs,
    ActionType.FetchTeamsTasksTabsFailed,
    ActionType.FetchTeamsTasksTabsSucceeded,
    ActionType.FetchTeamsMessageDetailsSucceeded
];
